<div class="content-wrapper">
  <div class="title-wrapper">
    <div class="wrapper-text-h3">{{ settings?.name }}</div>
  </div>
  <div class="input-div">
    <div>
      <mat-form-field class="select-field" appearance="outline">
        <mat-label>Group Placement Type</mat-label>
        <mat-select
          [(ngModel)]="selectedEntryOption"
          (ngModelChange)="updateEntryFlowType()"
          aria-label="Group Placement Type"
          placeholder="Group Placement Type"
          matInput
          required
        >
          <mat-option default value="default">Default</mat-option>
          <div
            [matTooltip]="
              !allowGroupFormers ? 'To create group formers, please enable Smart Badging for this Scootaverse' : ''
            "
            matTooltipPosition="right"
          >
            <mat-option [disabled]="!allowGroupFormers" value="group"> Group Former </mat-option>
          </div>
          <div
            [matTooltip]="
              hasAssignedEntryFlow
                ? 'Sorry, you can\'t add a Starting Point entry flow because other entry flow types are already attached to other rooms in this Scootaverse. To proceed with this entry flow, you can delete the other one(s).'
                : ''
            "
            matTooltipPosition="right"
          >
            <mat-option [disabled]="hasAssignedEntryFlow" value="custom">Custom Starting Point</mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>

    @if (selectedEntryOption !== 'custom') {
      <div>
        <mat-button-toggle-group
          [(ngModel)]="selectedPattern"
          (ngModelChange)="updateEntryFlowType()"
          class="custom-toggle-button"
          #toggleBtn="matButtonToggleGroup"
        >
          <mat-button-toggle class="toggle-option" default value="spiral"> Spiral </mat-button-toggle>
          <mat-button-toggle class="toggle-option" value="grid"> Grid </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    } @else {
      <div>Drag and drop the blue dot to select where attendees will start:</div>
    }

    <div class="pattern-wrapper">
      <div class="pattern-container">
        <div class="pattern-title">Entry Flow Preview</div>
        <div class="pattern-image">
          @if (selectedEntryOption !== 'custom') {
            <img title="Entry pattern" src="{{ getImagePath() }}" class="pattern-image-svg" />
          } @else {
            <div class="single-point-container boundary-starting-point">
              <div
                class="pattern-image-single-dot-container"
                cdkDragBoundary=".boundary-starting-point"
                cdkDrag
                [cdkDragFreeDragPosition]="dragPosition"
                (cdkDragEnded)="dragEnd($event)"
              >
                <img class="pattern-image-single-dot" title="Entry pattern" src="{{ getImagePath() }}" />
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="group-size-container">
      <div class="participants-description-text">Participants in this entry flow will spawn in groups of...</div>
      <div class="slider-wrapper">
        <div class="group-size-counter">
          {{ groupSizeCountSelected }}
        </div>
        <div class="group-size-slider">
          <mat-slider
            class="slider"
            aria-labelledby="group-size-slider"
            [max]="maxGroupSize"
            [min]="1"
            [discrete]="true"
            #ngSlider
            ><input
              placeholder="slider"
              matSliderThumb
              [value]="groupSizeCountSelected"
              (change)="onGroupSizeChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
              #ngSliderThumb="matSliderThumb"
            />
          </mat-slider>
        </div>
      </div>

      <div class="participants-information-text">
        Maximum Scootaverse group size: {{ maxGroupSize }}.
        <a class="settings-link" (click)="onClickSettings()"
          >Click here to change it. <mat-icon class="new-tab-icon">open_in_new</mat-icon></a
        >
      </div>
    </div>
  </div>
</div>
<div class="footer-wrapper">
  <button data-testid="primaryButton" class="primary-button" (click)="nextStep()">Next</button>
</div>
